import * as Yup from 'yup';
import { Locale } from '@synergy/models';

import { topicFormValuesFieldNames } from './models/topic-formik-values';

export const topicsDetailValidationSchema = (currentLocale: Locale) =>
    Yup.object().shape({
        [topicFormValuesFieldNames.title]: Yup.object().shape({
            [currentLocale]: Yup.string().required('app.error.required'),
        }),
        [topicFormValuesFieldNames.description]: Yup.object().shape({
            [currentLocale]: Yup.string().required('app.error.required'),
        }),
    });
